import { render } from "./news-category.vue?vue&type=template&id=76f38bfe&scoped=true"
import script from "./news-category.vue?vue&type=script&lang=js"
export * from "./news-category.vue?vue&type=script&lang=js"

import "./news-category.vue?vue&type=style&index=0&id=76f38bfe&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\ahuview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76f38bfe"]])

export default __exports__